import styled from "styled-components";

export const List = styled.ul`
  list-style: none;
  margin: 0 auto;
  padding: 0;
  display: flex;
  justify-content: center;
  gap: 8px;
`;

export const Wrapper = styled.div`
  margin-top: 50px;
  flex-direction: column;
  display: flex;
  align-items: center;
`;
